import React from "react";
import {
  FaGlobe,
  FaPenNib,
  FaPaintBrush,
  FaPrint,
  FaRegAddressCard,
  FaBuilding,
  FaCamera,
  FaWifi,
  FaRegistered,
  FaAd,
  FaTools,
} from "react-icons/fa";
import "../styles/Services.css";
import { Link } from "react-router-dom";

const Services = () => {
  const services = [
    {
      icon: <FaGlobe />,
      title: "Website Design & Development",
      description: "Custom websites built for speed, UX, and growth.",
      link: "webServices",
    },
    {
      icon: <FaTools />,
      title: "IT Support Services",
      description:
        "Computer repairs, software installation, optimization, and support.",
      link: "itSupport",
    },
    {
      icon: <FaPenNib />,
      title: "Business Cards",
      description: "Creative and professional business card designs.",
      link: "BusinessCards",
    },
    {
      icon: <FaBuilding />,
      title: "Company Profiles",
      description:
        "Design impactful company profiles that reflect your values and goals.",
      link: "profiles",
    },
    {
      icon: <FaPaintBrush />,
      title: "Flyers & Posters",
      description:
        "Bold and vibrant promotional materials tailored for your business.",
      link: "flyers",
    },
    {
      icon: <FaPrint />,
      title: "Typing & Printing",
      description:
        "Efficient document typing, formatting, and high-quality printing services.",
      link: "typingPrinting",
    },
    {
      icon: <FaRegAddressCard />,
      title: "Logo Design",
      description:
        "Custom logos that speak your brand identity clearly and creatively.",
      link: "logos",
    },
    {
      icon: <FaCamera />,
      title: "Graphics Design",
      description:
        "All your graphic needs from banners to digital ads handled by experts.",
      link: "graphicsDesign",
    },
    {
      icon: <FaWifi />,
      title: "Internet Access",
      description: "Affordable and fast internet packages available on site.",
      link: "internetAccess",
    },
    {
      icon: <FaRegistered />,
      title: "Company Registration",
      description:
        "Get your business officially registered fast and hassle-free.",
      link: "companyRegistration",
    },
    {
      icon: <FaAd />,
      title: "Digital Marketing",
      description:
        "Let us manage your online presence across platforms professionally.",
      link: "digitalMarketing",
    },
  ];

  return (
    <div className="services-page container">
      <h1>Our Services</h1>
      <div className="services-grid">
        {services.map((service, index) => (
          <Link
            to={`/services/${service.link}`}
            key={index}
            className="service-card-link"
          >
            <div className="service-card">
              <div className="icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <span className="learn-more-text">View</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Services;
